import { BASE_ENDPOINT } from "../../endpoint";

export const migrateTableService = async (
	token: string,
	institutionId: string,
	tableName: string
) => {
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/migration/migrate-table/${institutionId}/${tableName}`,
			{
				method: "POST",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			}
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
